import { Skeleton, Typography } from 'antd'
import React, { Suspense } from 'react'

import { Tenants } from './Tenants'

export const TenantsPage = () => {
  return (
    <>
      <Typography.Title>Tenants</Typography.Title>

      <Suspense fallback={<Skeleton />}>
        <Tenants />
      </Suspense>
    </>
  )
}
